import {accordion} from "../../sources/js/functions/accordion";

accordion('.text-video__caption', '.text-video__content');
